import { render, staticRenderFns } from "./indexLayout.vue?vue&type=template&id=f1a06b3c&scoped=true&"
import script from "./indexLayout.vue?vue&type=script&lang=js&"
export * from "./indexLayout.vue?vue&type=script&lang=js&"
import style0 from "./indexLayout.vue?vue&type=style&index=0&id=f1a06b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a06b3c",
  null
  
)

export default component.exports